import React from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import helpCardTrainingIllustration from '../../assets/images/helpCardTrainingIllustration.svg';
import lmsHelpCardIllustration from '../../assets/images/lmsHelpCardIllustration.svg';

export const webinarTrainingCardContent = {
  illustration: helpCardTrainingIllustration,
  title: <Trans id="help-card-webinar-title">Live training</Trans>,
  description: (
    <Trans id="help-card-webinar-description-short">Take a tour of Front and get questions answered.</Trans>
  ),
  actionLabel: <Trans id="help-card-webinar-cta">Sign up</Trans>,
};

export const webinarTrainingCardContentFull = {
  ...webinarTrainingCardContent,
  description: (
    <Trans id="help-card-webinar-description-short">
      Join a live session to take a tour of Front with our product experts and get questions answered.
    </Trans>
  ),
};

export const lmsCardContent = {
  illustration: lmsHelpCardIllustration,
  title: <Trans id="help-card-lms-title">Take courses</Trans>,
  description: (
    <Trans id="help-card-lms-description-short">Achieve your goals with hands-on trainings.</Trans>
  ),
  actionLabel: <Trans id="help-card-lms-cta">Front Academy</Trans>,
};

export const lmsCardContentFull = {
  ...lmsCardContent,
  description: (
    <Trans id="help-card-lms-description-short">
      Enroll in hands-on training to achieve your goals through self-paced learning paths, test your
      knowledge, and train your team.
    </Trans>
  ),
};

export const individualTrainingCardContent = {
  illustration: helpCardTrainingIllustration,
  title: <Trans id="help-card-training-title">Book a setup call</Trans>,
  description: (
    <Trans id="help-card-training-description-short">Ask questions and get setup help in a 1:1 call.</Trans>
  ),
  actionLabel: <Trans id="help-card-training-cta">Pick your time</Trans>,
};

export const individualTrainingCardContentFull = {
  ...individualTrainingCardContent,
  description: (
    <Trans id="help-card-training-description-full">
      Get help from a product expert on setting up Front and building your workflow in a 1:1 call.
    </Trans>
  ),
};
